/*
 * IATILoader - the single loading indicator for the whole site.
 *
 * Replaces three separate jQuery UI modal dialogs (aerobilet_overlay in
 * main.js, aerobilet_overlay_new in loading-flight.js, and the redirect overlay
 * in loginregister.js). Those used dialog({modal:true}), which injects a
 * full-screen .ui-widget-overlay that swallows every touch - the reason the
 * mobile site appeared frozen, and why returning to a backgrounded tab showed a
 * blank screen.
 *
 * This is a fixed strip at the top of the viewport with pointer-events:none, so
 * it cannot trap the user no matter what happens next. It owns its own markup
 * and styles so it works on any page that loads this file.
 *
 * Note on navigation: when the strip is shown immediately before a full-page
 * navigation, iOS Safari freezes painting of the outgoing document, so the
 * animation will not advance. Nothing client-side can change that. The strip
 * still renders, and crucially no longer blocks anything.
 */
var IATILoader = (function () {

	var STYLE_ID = 'iati-loader-style';
	var BAR_ID = 'iati-loader';

	var bar = null;
	var label = null;
	var depth = 0;

	function injectStyles() {
		if (document.getElementById(STYLE_ID)) {
			return;
		}
		var css =
			'#' + BAR_ID + '{position:fixed;top:0;left:0;right:0;z-index:99999;' +
			'pointer-events:none;display:none;}' +
			'#' + BAR_ID + ' .iati-loader-track{position:relative;height:4px;width:100%;' +
			'overflow:hidden;background:rgba(36,185,240,.25);}' +
			'#' + BAR_ID + ' .iati-loader-fill{position:absolute;top:0;bottom:0;left:0;width:35%;' +
			'background:#24b9f0;border-radius:0 2px 2px 0;' +
			'-webkit-animation:iatiLoaderSlide 1.15s ease-in-out infinite;' +
			'animation:iatiLoaderSlide 1.15s ease-in-out infinite;}' +
			'#' + BAR_ID + ' .iati-loader-label{display:block;margin:0 auto;max-width:90%;' +
			'padding:6px 14px;border-radius:0 0 6px 6px;background:#24b9f0;color:#fff;' +
			'font-size:13px;line-height:1.3;text-align:center;width:-moz-fit-content;' +
			'width:fit-content;box-shadow:0 1px 4px rgba(0,0,0,.2);}' +
			'#' + BAR_ID + ' .iati-loader-label:empty{display:none;}' +
			'@-webkit-keyframes iatiLoaderSlide{0%{left:-35%;}100%{left:100%;}}' +
			'@keyframes iatiLoaderSlide{0%{left:-35%;}100%{left:100%;}}' +
			'@media (prefers-reduced-motion: reduce){' +
			'#' + BAR_ID + ' .iati-loader-fill{-webkit-animation-duration:2.6s;animation-duration:2.6s;}}';

		var style = document.createElement('style');
		style.id = STYLE_ID;
		style.type = 'text/css';
		if (style.styleSheet) {
			style.styleSheet.cssText = css;
		} else {
			style.appendChild(document.createTextNode(css));
		}
		(document.head || document.getElementsByTagName('head')[0]).appendChild(style);
	}

	function ensure() {
		if (bar && document.body && document.body.contains(bar)) {
			return true;
		}
		if (!document.body) {
			return false;
		}
		injectStyles();

		bar = document.createElement('div');
		bar.id = BAR_ID;
		bar.setAttribute('role', 'progressbar');
		bar.setAttribute('aria-busy', 'true');

		var track = document.createElement('div');
		track.className = 'iati-loader-track';
		var fill = document.createElement('div');
		fill.className = 'iati-loader-fill';
		track.appendChild(fill);

		label = document.createElement('span');
		label.className = 'iati-loader-label';
		label.setAttribute('aria-live', 'polite');

		bar.appendChild(track);
		bar.appendChild(label);
		document.body.appendChild(bar);
		return true;
	}

	/** Looks up a localised message, falling back to empty rather than throwing. */
	function message(key) {
		try {
			if (key && typeof FmtMessage !== 'undefined' && FmtMessage.getMessage) {
				var text = FmtMessage.getMessage(key);
				// FmtMessage echoes the key back when it has no translation.
				return (text && text !== key) ? text : '';
			}
		} catch (ignored) {
		}
		return '';
	}

	return {
		/**
		 * @param text plain text to display, or null for the bar alone.
		 * Nested calls are counted so an inner hide() does not cancel an outer show().
		 */
		show: function (text) {
			try {
				depth++;
				if (!ensure()) {
					return;
				}
				label.textContent = text || '';
				bar.style.display = 'block';
			} catch (ignored) {
				// The loader must never break the action it is decorating.
			}
		},

		/**
		 * Shows the first key that resolves. Messages come from the backend
		 * message store rather than the repo, so a key cannot be verified at
		 * build time; later arguments act as fallbacks.
		 */
		showKey: function () {
			var text = '';
			for (var i = 0; i < arguments.length && !text; i++) {
				text = message(arguments[i]);
			}
			this.show(text);
		},

		hide: function () {
			try {
				depth = Math.max(0, depth - 1);
				if (depth === 0 && bar) {
					bar.style.display = 'none';
					label.textContent = '';
				}
			} catch (ignored) {
			}
		},

		/** Clears any nesting and hides unconditionally. */
		reset: function () {
			depth = 0;
			this.hide();
		}
	};
})();

/*
 * A navigation that is cancelled - the user taps back, or the browser restores
 * the page from bfcache - would otherwise leave the strip showing forever.
 */
if (typeof window !== 'undefined' && window.addEventListener) {
	window.addEventListener('pageshow', function (event) {
		if (event && event.persisted) {
			IATILoader.reset();
		}
	});
}
